"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const mobx_react_lite_1 = require("mobx-react-lite");
const react_1 = tslib_1.__importStar(require("react"));
const context_1 = require("../../../../context");
const Range_1 = tslib_1.__importDefault(require("../../../../ui-lib/Inputs/Range"));
const ErrorBoundary_1 = require("../../../ErrorBoundary");
const ModularVolumeRange = (0, mobx_react_lite_1.observer)(({ classes, ...props }) => {
    var _a;
    const componentName = "<VolumeRange/>";
    const ctx = (0, react_1.useContext)(context_1.PlayerUiContext);
    (0, ErrorBoundary_1.useUndefinedStoreError)((ctx === null || ctx === void 0 ? void 0 : ctx.player) != null, componentName);
    const modifyVolume = (ev) => {
        ctx.player.localAudioMuted = false;
        ctx.player.localAudioVolume = Number(ev.currentTarget.value);
    };
    const handleInputChange = (0, ErrorBoundary_1.useUIEventError)(modifyVolume, componentName);
    // I had to flip the boolean on the disabled button because it was making the button not work (originally !player?.remoteAudioEnabled)//
    return (ctx === null || ctx === void 0 ? void 0 : ctx.volumeRangeSupported) ? (react_1.default.createElement(Range_1.default, { ...props, classes: classes, onInput: handleInputChange, onChange: handleInputChange, value: (_a = ctx.player.localAudioVolume) !== null && _a !== void 0 ? _a : 0.5 })) : null;
});
// eslint-disable-next-line react/function-component-definition
const VolumeRangeWithErrorBoundary = ({ classes, ...props }) => {
    return (react_1.default.createElement(ErrorBoundary_1.ErrorBoundary, { render: () => react_1.default.createElement(Range_1.default, { classes: classes, ...props, disabled: true }) },
        react_1.default.createElement(ModularVolumeRange, { classes: classes, ...props })));
};
exports.default = VolumeRangeWithErrorBoundary;
//# sourceMappingURL=VolumeRange.js.map